import type Store from '~/types/Store';

import { ActionKeys } from './constants';

export const fetchStores = () =>
  <const>{
    type: ActionKeys.STORES_FETCH,
  };

export const fetchStoresError = (errorMessage: string) =>
  <const>{
    errorMessage,
    type: ActionKeys.STORES_FETCH_ERROR,
  };

export const fetchStoresSuccess = (stores: Store[]) =>
  <const>{
    payload: {
      stores,
    },
    type: ActionKeys.STORES_FETCH_SUCCESS,
  };

export type StoresActions =
  | ReturnType<typeof fetchStores>
  | ReturnType<typeof fetchStoresError>
  | ReturnType<typeof fetchStoresSuccess>;
